import { ITrackingProvider, IVimCoreTrackingUserData } from '../interface';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ConsoleTrackingProvider implements ITrackingProvider<{}> {
  init(config: {}): void {
    this.log('init', config);
  }

  setUserData(userId: number, userData?: IVimCoreTrackingUserData): void {
    this.log('setUserData', userId, userData);
  }

  track(event: string, data: Object): void {
    this.log('track', event, data);
  }

  page(pageId: string, pageContext: Object): void {
    this.log('page', pageId, pageContext);
  }

  resetUser(): void {
    this.log('resetUser');
  }

  setSource(source: string): void {
    this.log('setSource', source);
  }

  private log(...args: unknown[]): void {
    console.warn('Crm2 ConsoleTrackingProvider:', ...args);
  }
}
